import KivingReport from './views/reports/TenantSpecific/Abl/KivingReport.vue';
import NeoAdhocReport from './views/reports/TenantSpecific/Abl/NeoAdhocReport.vue';
import NeoMonthlyReport from './views/reports/TenantSpecific/Abl/NeoMonthlyReport.vue';
import NeoOfferReport from './views/reports/TenantSpecific/Abl/NeoOfferReport.vue';
import TigReport from './views/reports/TenantSpecific/Electronholding/TigReport.vue';
import TigCreate from './views/reports/TenantSpecific/Electronholding/TigCreate.vue';
import CustomReport from './views/reports/TenantSpecific/Further/CustomReport.vue';

// Currently only tenant specific reports are supported.
//
// To add a new tenant report:
// 1) Create a Vue component under `resources/ts/views/reports/TenantSpecific`.
// 2) Add an entry to `tenantConfig` with a unique `name` and `path`.
//    - Route objects are automatically generated from `tenantConfig` and
//      merged into the global `routes` array in `resources/ts/routes.ts`.
// 3) The reports index (`resources/ts/views/reports/Index.vue`) reads
//    `tenantConfig` to display cards for all tenant-specific reports.

export const tenantRoutesConfig = {
    abl: [
        {
            component: NeoMonthlyReport,
            key: 'neoMonthlyReport',
            label: 'NEO Havi Elszámoló',
            meta: {
                permission: 'worksheets.index',
                requiresAuth: true,
            },
            name: 'abl.reports.neoMonthlyReport',
            path: '/reports/abl/neoMonthlyReport',
            type: 'report',
        },
        {
            component: NeoAdhocReport,
            key: 'neoAdhocReport',
            label: 'NEO Eseti Elszámoló',
            meta: {
                permission: 'worksheets.index',
                requiresAuth: true,
            },
            name: 'abl.reports.neoAdhocReport',
            path: '/reports/abl/neoAdhocReport',
            type: 'report',
        },
        {
            component: NeoOfferReport,
            key: 'neoOfferReport',
            label: 'NEO Ajánlatok',
            meta: {
                permission: 'worksheets.index',
                requiresAuth: true,
            },
            name: 'abl.reports.neoOfferReport',
            path: '/reports/abl/neoOfferReport',
            type: 'report',
        },
        {
            component: KivingReport,
            key: 'kivingReport',
            label: 'Kiving Státusz Riport',
            meta: {
                permission: 'worksheets.index',
                requiresAuth: true,
            },
            name: 'abl.reports.kivingReport',
            path: '/reports/abl/kivingReport',
            type: 'report',
        },
    ],
    electronholding: [
        {
            component: TigReport,
            key: 'tig',
            label: 'Teljesítési igazolások',
            meta: {
                permission: 'worksheets.index',
                requiresAuth: true,
            },
            name: 'electronholding.reports.tig',
            path: '/reports/electronholding/tig',
            type: 'report',
        },
        {
            component: TigCreate,
            key: 'tig.create',
            label: 'Teljesítési igazolás létrehozása',
            meta: {
                permission: 'worksheets.index',
                requiresAuth: true,
            },
            name: 'electronholding.reports.tig.create',
            path: '/reports/electronholding/tig/create',
        },
    ],
    further: [
        {
            component: CustomReport,
            key: 'customReport',
            label: 'Further custom report',
            meta: {
                permission: 'worksheets.index',
                requiresAuth: true,
            },
            name: 'further.reports.customReport',
            path: '/reports/further/customReport',
            type: 'report',
        },
    ],
} as const;

export const tenantRoutes = Object.entries(tenantRoutesConfig).flatMap(([tenantKey, routes]) =>
    routes.map((route) => ({
        component: route.component,
        meta: {
            ...route.meta,
            tenant: tenantKey,
            type: route.type,
        },
        name: route.name,
        path: route.path,
    })),
);

